<template>
    <footer id="footer" v-bind:class="{ 'fixed-bottom' : stuck }" class="container-fluid mt-5">
        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-12 text-center text-light">
                        <!-- footer logo -->
                        <h3><router-link :to="{ name: 'home' }">aNewItem</router-link></h3>
                    </div>
                    <div class="col-md-6 col-12 text-light-green mt-1">
                        <!-- helpful links -->
                        <ul class="nav justify-content-center footer-links">
                            <li class="nav-item">
                                <router-link class="nav-link" title="Categories" :to="{ name: 'home' }">Categories</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" title="Post aNewItem" :to="{ name: 'shopping-cart' }">Shopping Cart</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" title="My Account" :to="{ name: 'customer-account' }">Account</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-3 col-12 footer-icons mt-2">
                        <!-- social links -->
                        <a href="https://www.instagram.com/anewitemapp" target="_blank"><i class="fab fa-instagram fa-lg"></i></a> &nbsp;
                        <a href="https://twitter.com/anewitemapp" target="_blank"><i class="fab fa-twitter-square fa-lg"></i></a> &nbsp;
                        <a href="https://www.facebook.com/anewitemapp" target="_blank"><i class="fab fa-facebook-square fa-lg"></i></a>
                        <a href="https://www.linkedin.com/company/anewitem" target="_blank"><i class="fab fa-linkedin fa-lg"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-10 offset-1">
                <!-- division line -->
                <hr class="footer-line">
            </div>
        </div>
        <div class="row">
            <div class="col-12 footer-copy mb-3">
                <!-- copyright -->
                <small>&copy; 2018-{{ new Date().getFullYear() }} aNewItem limited, subsidiary of Brondchux Company.</small>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters(['fixedFooter']),
        stuck() {
            return this.fixedFooter
        }
    }
}
</script>